// extracted by mini-css-extract-plugin
export default {"wrap":"EventsList_wrap__cPeXM","title":"EventsList_title__xjaVR","pre-title":"EventsList_pre-title__x2f3i","post-title":"EventsList_post-title__T8uJ8"};